import React from 'react';
import { useUserInfo } from '../../hooks';

function EntryCheck(props) {
  const { info } = useUserInfo();
  return (
    <React.Fragment>
      {props[info.entryType]}
    </React.Fragment>
  );
}

export default EntryCheck;